export default __webpack_public_path__ + "static/media/Nexus_6_piccolo_display_trasparent_list.c7d51b0f.png";